<!--
  Copyright (C) 2020 ExploRêve

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>.

  Full source code is available at <https://gitlab.com/exploreve/frontend>.
-->

<template>
  <div>
    <b-modal
      size="xl"
      hide-footer
      ref="message_write_modal"
      header-bg-variant="light"
      body-bg-variant="light"
      no-close-on-backdrop
      no-close-on-esc
    >
      <template v-slot:modal-header>
        <h3>
          Écris un message pour un·e autre explorêveur·euse !
        </h3>
      </template>
      <b-container>
        <div class="slideshow-container">
          <!-- Full-width images with number and caption text -->
          <div class="mySlides" style="display: block;">
            <p>
              Ce message sera envoyé à une autre personne de la Troposphère, qui a à peu près ton âge, mais qui ne fait
              pas du scoutisme dans la même association que toi !
            </p>
            <br />
            <span> D’abord, quelques informations pour savoir qui tu es :</span>
            <b-form-group class="mt-2">
              <b-form-input
                v-model="user_name"
                type="text"
                required
                placeholder="Prénom (ne mets pas ton nom de famille)"
                :state="user_name_valid"
              ></b-form-input>
              <b-form-invalid-feedback v-if="user_name_empty">
                Il faut mettre ton nom
              </b-form-invalid-feedback>
              <b-form-invalid-feedback v-if="user_name_already_taken">
                Ce nom d'utilisateur est déjà utilisé
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group class="mt-2">
              <b-form-input
                v-model="user_age"
                type="number"
                required
                placeholder="Ton age"
                :state="user_age_valid"
              ></b-form-input>
              <b-form-invalid-feedback v-if="!user_age_valid">
                Il faut mettre ton age
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group class="mt-2">
              <b-form-select v-model="user_mvt" :options="scouts_mvts" required :state="user_mvt_valid"></b-form-select>
              <b-form-invalid-feedback v-if="!user_mvt_valid">
                A quel mouvement appartient plus ?
              </b-form-invalid-feedback>
            </b-form-group>
          </div>

          <div class="mySlides">
            <p>
              Tu peux choisir de ne répondre qu’avec des choses réelles, mais tu peux aussi rêver, inventer… l’idée
              c’est que ce message soit à ton image !
            </p>
            <div class="d-flex justify-content-start mt-3">
              <span>Si j’étais un métier, je serais</span>
              <b-form-group class="ml-2">
                <b-form-input
                  v-model="job"
                  type="text"
                  placeholder="Nom du métier"
                  required
                  :state="job_valid"
                ></b-form-input>
                <b-form-invalid-feedback v-if="!job_valid">
                  Il faut mettre un métier
                </b-form-invalid-feedback>
              </b-form-group>
              <span class="ml-2">car</span>
              <b-form-group class="ml-2">
                <b-form-input
                  v-model="job_reason"
                  type="text"
                  placeholder="Explications"
                  required
                  :state="job_reason_valid"
                ></b-form-input>
                <b-form-invalid-feedback v-if="!job_reason_valid">
                  Il faut expliquer ton choix
                </b-form-invalid-feedback>
              </b-form-group>
            </div>
            <div class="d-flex justify-content-start">
              <span>Si j’étais un lieu, je serais</span>
              <b-form-group class="ml-2">
                <b-form-input
                  v-model="place"
                  type="text"
                  placeholder="Nom du lieu"
                  required
                  :state="place_valid"
                ></b-form-input>
                <b-form-invalid-feedback v-if="!place_valid">
                  Il faut mettre un lieu
                </b-form-invalid-feedback>
              </b-form-group>
              <span class="ml-2">car</span>
              <b-form-group class="ml-2">
                <b-form-input
                  v-model="place_reason"
                  type="text"
                  placeholder="Explications"
                  required
                  :state="place_reason_valid"
                ></b-form-input>
                <b-form-invalid-feedback v-if="!place_reason_valid">
                  Il faut expliquer ton choix
                </b-form-invalid-feedback>
              </b-form-group>
            </div>
            <div class="d-flex justify-content-start">
              <span>Si j’étais un personnage, je serais</span>
              <b-form-group class="ml-2">
                <b-form-input
                  v-model="personality"
                  type="text"
                  placeholder="Nom du personnage"
                  required
                  :state="personnality_valid"
                ></b-form-input>
                <b-form-invalid-feedback v-if="!personnality_valid">
                  Il faut mettre ton personnage
                </b-form-invalid-feedback>
              </b-form-group>
              <span class="ml-2">car</span>
              <b-form-group class="ml-2">
                <b-form-input
                  v-model="personnality_reason"
                  type="text"
                  placeholder="Explications"
                  required
                  :state="personnality_reason_valid"
                ></b-form-input>
                <b-form-invalid-feedback v-if="!personnality_reason_valid">
                  Il faut expliquer ton choix
                </b-form-invalid-feedback>
              </b-form-group>
            </div>
            <div class="d-flex justify-content-start">
              <span>Ce que j’apprécie le plus chez mes ami·es c’est</span>
              <b-form-group class="ml-2">
                <b-form-input
                  v-model="like_about_friends"
                  type="text"
                  placeholder="Explications"
                  required
                  :state="like_about_friends_valid"
                ></b-form-input>
                <b-form-invalid-feedback v-if="!like_about_friends_valid">
                  Il faut expliquer ton choix
                </b-form-invalid-feedback>
              </b-form-group>
            </div>
            <div class="d-flex justify-content-start">
              <span>Ce que je peux faire dans le scoutisme mais pas ailleurs c’est</span>
              <b-form-group class="ml-2">
                <b-form-input
                  v-model="scouting_activity"
                  type="text"
                  placeholder="Explications"
                  required
                  :state="scouting_activity_valid"
                ></b-form-input>
                <b-form-invalid-feedback v-if="!scouting_activity_valid">
                  Il faut expliquer ton choix
                </b-form-invalid-feedback>
              </b-form-group>
            </div>
          </div>

          <div class="mySlides">
            <p>
              Pendant notre long voyage, les Fantômes de l'Ennui sont toujours aux aguets ! Et toi, qu’est-ce que tu
              fais quand tu t’ennuies ? Tu peux partager une idée pour s’occuper pendant les longs voyages, mais aussi
              ce que tu aimes faire quand tu as du temps libre et pas d’obligation…
            </p>
            <b-form-group>
              <b-form-textarea
                v-model="bored_activity"
                type="text"
                required
                placeholder="Tes activités quand tu t’ennuies..."
                :state="bored_activity_valid"
                class="mw-textarea"
              ></b-form-textarea>
              <b-form-invalid-feedback v-if="!bored_activity_valid">
                Ton message doit faire moins de 400 caractères !
              </b-form-invalid-feedback>
            </b-form-group>
            <div class="d-flex justify-content-center">
              <div class="d-flex flex-column">
                <button type="submit" :disabled="!is_complete" class="send" @click="send">Envoyer mon message</button>
                <div class="text-danger" v-if="!is_complete">
                  Vérifie que tu as bien rempli toutes les pages
                </div>
              </div>
            </div>
          </div>
        </div>
        <br />

        <!-- The dots/circles -->
        <div style="text-align: center;">
          <a class="prev" @click="plusSlides(-1)">&#10094;</a>
          <span class="dot active" @click="currentSlide(1)"></span>
          <span class="dot" @click="currentSlide(2)"></span>
          <span class="dot" @click="currentSlide(3)"></span>
          <a class="next" @click="plusSlides(1)">&#10095;</a>
        </div>
      </b-container>
    </b-modal>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import Service from "@/services/messages";
export default {
  data: function () {
    return {
      sending: false,
      slideIndex: 1,
      user_name: "",
      user_mvt: null,
      user_age: "",
      bored_activity: "",
      scouts_mvts: [
        { value: null, text: "Mouvement de scoutisme" },
        "SGDF",
        "EEDF",
        "EEUDF",
        "EEIF",
        "SMF",
        "EDLN",
        "AGSE",
        "SUF",
        "FEE",
        "Ecl Neutres",
        "autre"
      ],
      errors: [],
      job: "",
      job_reason: "",
      place: "",
      place_reason: "",
      personality: "",
      personnality_reason: "",
      like_about_friends: "",
      scouting_activity: ""
    };
  },
  methods: {
    plusSlides(n) {
      this.slideIndex += n;
      this.showSlides();
    },

    currentSlide(n) {
      if (this.slideIndex < n) return;
      this.slideIndex = n;
      this.showSlides();
    },
    showSlides() {
      var slides = document.getElementsByClassName("mySlides");
      var dots = document.getElementsByClassName("dot");
      if (this.slideIndex > slides.length) {
        this.slideIndex = 1;
      }
      if (this.slideIndex < 1) {
        this.slideIndex = slides.length;
      }
      for (let i = 0; i < slides.length; i++) {
        slides[i].style.display = "none";
      }
      for (let i = 0; i < dots.length; i++) {
        dots[i].className = dots[i].className.replace(" active", "");
      }
      slides[this.slideIndex - 1].style.display = "block";
      dots[this.slideIndex - 1].className += " active";
    },
    send() {
      if (!this.sending) {
        this.sending = true;
        const request_body = {
          display_name: this.user_name,
          age: parseInt(this.user_age),
          movement: this.user_mvt,
          job: this.job,
          job_reason: this.job_reason,
          place: this.place,
          place_reason: this.place_reason,
          personality: this.personality,
          personality_reason: this.personnality_reason,
          bored_activity: this.bored_activity,
          like_about_friends: this.like_about_friends,
          scouting_activity: this.scouting_activity
        };
        Service.submit(request_body).then(() => {
          this.$refs.message_write_modal.hide();
          this.$store.dispatch("changeState", "PLAY");
          this.sending = false;

          Service.getRandomMessage().then((message) => {
            this.$store.dispatch("messageReceived", message);
          });
        });
      }
    }
  },
  computed: {
    ...mapGetters(["game_state"], "game_state"),
    user_name_valid: function () {
      return !this.user_name_empty && !this.user_name_already_taken;
    },
    user_name_empty: function () {
      return this.user_name.trim().length === 0;
    },
    user_age_valid: function () {
      return this.user_age > 0 && this.user_age < 120;
    },
    user_mvt_valid: function () {
      return this.scouts_mvts.findIndex((e) => e === this.user_mvt) !== -1 && this.user_mvt !== null;
    },
    user_name_already_taken: function () {
      const valid = this.errors.findIndex((e) => e.field === "user_name") !== -1;
      return valid;
    },
    bored_activity_valid: function () {
      return this.bored_activity.trim().length < 400 && this.bored_activity.trim().length > 0;
    },
    job_valid: function () {
      return this.job.trim().length !== 0;
    },
    job_reason_valid: function () {
      return this.job_reason.trim().length !== 0;
    },
    place_valid: function () {
      return this.place.trim().length !== 0;
    },
    place_reason_valid: function () {
      return this.place_reason.trim().length !== 0;
    },
    personnality_valid: function () {
      return this.personality.trim().length !== 0;
    },
    personnality_reason_valid: function () {
      return this.personnality_reason.trim().length !== 0;
    },
    like_about_friends_valid: function () {
      return this.like_about_friends.trim().length !== 0;
    },
    scouting_activity_valid: function () {
      return this.scouting_activity.trim().length !== 0;
    },
    is_complete: function () {
      return (
        this.scouting_activity_valid &&
        this.like_about_friends_valid &&
        this.personnality_reason_valid &&
        this.personnality_valid &&
        this.place_reason_valid &&
        this.place_valid &&
        this.job_reason_valid &&
        this.job_valid &&
        this.bored_activity_valid &&
        this.user_mvt_valid &&
        this.user_age_valid &&
        this.user_name_valid
      );
    }
  },
  watch: {
    game_state: function (value) {
      if (value === "MESSAGE_WRITE") {
        this.$emit("audio", { action: "play-once", id: "music02" });
        this.$refs.message_write_modal.show();
      }
    }
  }
};
</script>
<style lang="scss" scoped>
* {
  box-sizing: border-box;
}

.left {
  max-width: 300px !important;
}
p {
  font-family: Faune;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 32px;

  color: #000000;
}
span {
  font-family: Faune;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;

  color: #000000;
}
.send {
  font-family: Faune;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 36px;
  display: flex;
  align-items: center;
  text-align: center;

  color: #ffffff;
  background: #5e2a57;
  border-radius: 5px;
  padding: 8px 34px;
}

.left,
.right {
  font-family: "Faune";
  display: table;
  padding: 10px;
  background-color: white;
  border-radius: 5px;
  margin: 20px;
  max-width: 300px;
  z-index: 5;
  width: intrinsic; /* Safari/WebKit utilisent un nom non-standard */
  width: -moz-max-content; /* Firefox/Gecko */
  width: -webkit-max-content;
}

.left {
  padding-left: 0px;
  margin-left: 20px;
  margin-right: auto;
}

.right {
  padding-right: 0px;
  margin-right: 10px;
  margin-left: auto;
}

p {
  display: table-cell;
  vertical-align: middle;
}

.long {
  max-width: 300px !important;
}

.arrowleft {
  position: relative;
  content: "";
  left: -20px;
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-right: 20px solid white;
  z-index: 5;
}

.arrowright {
  position: relative;
  content: "";
  left: 20px;
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;

  border-left: 20px solid white;
}

.slideshow-container {
  width: auto;
  height: 450px;
  position: relative;
  margin: auto;
}

/* Hide the images by default */
.mySlides {
  display: none;
  height: 400px;
}

/* Next & previous buttons */
.prev,
.next {
  cursor: pointer;
  width: 20px;
  height: 20px;
  padding: 10px;
  margin: 10px;
  color: white !important;
  font-weight: bold;
  font-size: 18px;
  background-color: #cb8c31;
  transition: 0.6s ease;
  border-radius: 3px;
  user-select: none;
  top: 5px;
}

/* On hover, add a black background color with a little bit see-through */
.prev:hover,
.next:hover {
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
}

button:disabled {
  background: #9e9e9e;
  cursor: not-allowed;
}

/* The dots/bullets/indicators */
.dot {
  cursor: pointer;
  height: 8px;
  width: 8px;
  margin: 0 5px;
  background-color: #bbb;
  border-radius: 50%;
  display: inline-block;
  transition: background-color 0.6s ease;
}

.active,
.dot:hover {
  background-color: #717171;
}

.mw-textarea {
  margin-top: 15px;
}
</style>
